import * as yup from "yup";

const QueryValidationSchema = yup.object().shape({
  queryOutcome: yup.string().required("Please make a selection."),
  employeeMessage: yup
    .string()
    .max(300)
    .required("Please complete the message field."),
});

export default QueryValidationSchema;
